import { Feature } from './types/Billing';
import { ValidationError as ValidationErrorType } from './types/BotFlow';

export class PlanUpgradeRequiredError extends Error {
  missingFeatures: Feature[];

  constructor(message: string, missingFeatures: Feature[]) {
    super(message);
    this.name = 'PlanUpgradeRequiredError';
    this.missingFeatures = missingFeatures;
  }
}

export class FlowValidationError extends Error {
  validationErrors: ValidationErrorType[];

  constructor(message: string, validationErrors: ValidationErrorType[]) {
    super(message);
    this.name = 'FlowValidationError';
    this.validationErrors = validationErrors;
  }
}
